import { render, staticRenderFns } from "./dndList.vue?vue&type=template&id=661ec53c"
import script from "./dndList.vue?vue&type=script&lang=js"
export * from "./dndList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports